// Sahm 230E
import React from "react";
import {
   CommonRows, CreelTensionRow, GearCRow, GearDRow, GearERow, GearFRow,
   InputRangeRow, MinMaxRow, RunTimeRow, WindingTensionRow
} from "./index";

export default function MachineSahm() {
   return (
      <>
         <InputRangeRow
            titleProp={"Clock Setting"}
            descriptionProp={"m"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={999999} //some default value
            propertyNameProp={"clockSet"}
            errorDialogueProp={"0-999,999 only"}
            floatProp={false}
         />
         <RunTimeRow />
         <CreelTensionRow />
         <MinMaxRow
            titleProp={"Back Press"}
            descriptionProp="kg"
            minProp1={0.0}
            maxProp1={10.0}
            floatProp1={true}
            errorProp1={"0.00-10.00 only"}
            minProp2={0.0}
            maxProp2={10.0}
            floatProp2={true}
            errorProp2={"0.00-10.00 only"}
            valueProp1={"backPressMin"}
            valueProp2={"backPressMax"}
         />
         <WindingTensionRow windingTension />
         <GearCRow minProp={18} maxProp={102} errorProp={"18-102 only"} />
         <GearDRow minProp={18} maxProp={102} errorProp={"18-102 only"} />
         <GearERow minProp={18} maxProp={102} errorProp={"18-102 only"} />
         <GearFRow minProp={18} maxProp={102} errorProp={"18-102 only"} />
         <InputRangeRow
            titleProp={"Applicator Roll RPM"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.0}
            maxProp={40.0}
            propertyNameProp={"applicatorRollRPM"}
            errorDialogueProp={"0.0-40.0 only"}
            floatProp={true}
         />
         <InputRangeRow
            titleProp={"Pre-Feeder Roll Pressure"}
            descriptionProp={"psi"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={99}
            propertyNameProp={"preFeedPressure"}
            errorDialogueProp={"0-99 only"}
            floatProp={false}
         />
         <InputRangeRow
            titleProp={"Delivery Speed"}
            descriptionProp={"ypm"}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0}
            maxProp={500}
            propertyNameProp={"deliverySpeed"}
            errorDialogueProp={"0-500 only"}
            floatProp={false}
         />
         <CommonRows />
      </>
   );
}
